import BiLike from '@meronex/icons/bi/BiLike';
import icon from './StyledIcon';
export default icon(BiLike);
